import axiosInstance from './instance';

const brandApi = {
  // 브랜드 담당자 정보 불러오기(Get brand manager information)
  brandManager(brandCode: string) {
    return axiosInstance.get(`/guest/${brandCode}/brand/manager`);
  },

  // 브랜드 정보 불러오기(Get brand information)
  // task-0220: falsy brandCode → /guest//brand 401 방지 (중앙 가드)
  brandInfo(brandCode: string) {
    if (!brandCode) {
      return Promise.resolve(null);
    }
    return axiosInstance.get(`/guest/${brandCode}/brand`);
  },

  // 브랜드 설정 정보 조회
  getBrandProperties() {
    return axiosInstance.get('/brand/properties');
  },

  // 스탠다드 기본 캠퍼스 조회(Get standard basic campus)
  getStandardBasicCampus() {
    return axiosInstance.get(`/guest/brands?isDefault=true`);
  },

  // 브랜드 검색(Search brand)
  searchBrand(searchKeyword: string) {
    return axiosInstance.get(`/guest/brands?searchKeyword=${searchKeyword}`);
  },
};

export default brandApi;
